import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "vw0wim-0"
})(["display:inline-block;border-image-source:none;border-image-width:0;padding:0;"]);